import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props extends React.PropsWithChildren<ChakraV3.GridItemProps> {
  label: string;
}

export const ProfileItem = (props: Props) => {
  const { label, children, ...rest } = props;

  return (
    <ChakraV3.GridItem {...rest}>
      <ChakraV3.Stack gap={0}>
        <ChakraV3.Text fontSize='sm' fontWeight='semibold'>
          {label}
        </ChakraV3.Text>
        <ChakraV3.Stack fontSize='sm' color='gray.600'>
          {children}
        </ChakraV3.Stack>
      </ChakraV3.Stack>
    </ChakraV3.GridItem>
  );
};
